import { CrudStoreItemScout } from 'legacy/lut/classes/models/CrudStoreItemScout'
import { IFormPartnerCSI } from 'legacy/lut/classes/models/IFormMyPartnerCSI'
import { IAction } from 'legacy/lut/classes/models/onboarding/IAction'

import { IForm } from 'core-components/classes/models/IForm'
import { CrudStore } from 'core/types/crudStore'

import OnboardingStoreService from './OnboardingStoreService'

const asyncForEach = async <T>(array: T[], callback: (item: T) => any) => {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index])
  }
}

export class CrudConnectorsScout {
  public static updatePartnerListCSI = async (
    formId: string,
    items: IForm[]
  ): Promise<IFormPartnerCSI[]> => {
    const resultArr: IFormPartnerCSI[] = []
    if (!items[0]) {
      return resultArr
    }
    const item = items[0]
    const crud = CrudStore.get(CrudStoreItemScout.PartnerListCSI)

    switch (formId) {
      case `423`:
        const oldItem = await crud.getById(item['EntryId'])
        if (oldItem) {
          for (const field in item) {
            if (field && field !== 'Description') {
              oldItem[field] = item[field]
            } else if (field === 'Description') {
              oldItem['CampaignDescription'] = item['Description']
            }
          }
          resultArr.push(oldItem)
        }
        return items as IFormPartnerCSI[]
    }
    return resultArr
  }

  public static fetchActions = async (items: IAction[]): Promise<IAction[]> => {
    const resultArr: IAction[] = []
    await asyncForEach(items, async (item) => {
      const processParent = items.find((el) => el.Process === item.Process && !el.ParentUUID)
      resultArr.push({
        ...item,
        ProcessSortOrder: processParent ? processParent.SortOrder : 0,
      })

      return
    })
    return OnboardingStoreService.sortFunction(resultArr)
  }
}
